/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Terms_Add_New_Term_TitleInputs */

const en_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new term`)
};

const fr_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un nouveau terme`)
};

const de_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuen Begriff hinzufügen`)
};

const it_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi nuovo termine`)
};

const ru_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить новый термин`)
};

const es_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir nuevo término`)
};

const zh_cn2_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加新术语`)
};

const ja_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい用語を追加`)
};

const hi_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया शब्द जोड़ें`)
};

const pt_pt2_knp_terms_add_new_term_title = /** @type {(inputs: Knp_Terms_Add_New_Term_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar novo termo`)
};

/**
* | output |
* | --- |
* | "Add new term" |
*
* @param {Knp_Terms_Add_New_Term_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_add_new_term_title = /** @type {((inputs?: Knp_Terms_Add_New_Term_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Add_New_Term_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_add_new_term_title(inputs)
	if (locale === "de") return de_knp_terms_add_new_term_title(inputs)
	if (locale === "it") return it_knp_terms_add_new_term_title(inputs)
	if (locale === "ru") return ru_knp_terms_add_new_term_title(inputs)
	if (locale === "es") return es_knp_terms_add_new_term_title(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_add_new_term_title(inputs)
	if (locale === "ja") return ja_knp_terms_add_new_term_title(inputs)
	if (locale === "hi") return hi_knp_terms_add_new_term_title(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_add_new_term_title(inputs)
	return en_knp_terms_add_new_term_title(inputs)
});